export default __webpack_public_path__ + "static/media/icon-buscador.c3591689.svg";